import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { NumberInputModal } from "./NumberInputModal";
import { formatDecimalNumber } from "./utils";
export function NumberInput(_ref) {
  var children = _ref.children,
      value = _ref.value,
      title = _ref.title,
      unit = _ref.unit,
      _ref$incrementable = _ref.incrementable,
      incrementable = _ref$incrementable === void 0 ? false : _ref$incrementable,
      onChange = _ref.onChange,
      minValue = _ref.minValue,
      maxValue = _ref.maxValue,
      decimals = _ref.decimals;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpened = _useState2[0],
      setIsOpened = _useState2[1];

  minValue = minValue || 0;
  maxValue = maxValue || maxValue === 0 ? maxValue : 65535;
  decimals = decimals || 0;

  var handleClose = function handleClose() {
    setIsOpened(false);
  };

  var handleDone = function handleDone(newValue) {
    onChange(newValue);
    setIsOpened(false);
  };

  var handleClick = function handleClick() {
    if (typeof value === "undefined") {
      return;
    }

    setIsOpened(true);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NumberInputModal, {
    key: isOpened ? "opened" : String(value),
    isOpen: isOpened,
    initialValue: value,
    title: title,
    unit: unit,
    incrementable: incrementable,
    minValue: minValue,
    maxValue: maxValue,
    decimals: decimals,
    onClose: handleClose,
    onDone: handleDone
  }), children({
    onClick: handleClick
  }));
}